import { LandingHeader } from "@/components/landing/LandingHeader";
import { useAirHeaderScrolled } from "@/components/site/useAirHeaderScrolled";
import type { Locale } from "@/types";

interface AirHeaderProps {
  locale: Locale;
  introComplete: boolean;
  onLocaleChange(): void;
}

export function AirHeader({ locale, introComplete, onLocaleChange }: AirHeaderProps) {
  const scrolled = useAirHeaderScrolled({ scrollOffset: 8 });

  return (
    <LandingHeader
      variant="air"
      locale={locale}
      introComplete={introComplete}
      scrolled={scrolled}
      onLocaleChange={onLocaleChange}
    />
  );
}
